/// <amd-module name="Dashboards/DashboardView/src/components/complementary/WidgetCatalogProxy" />
import * as React from "react";

import { WidgetCatalogProps } from "Dashboards/WidgetContracts/Internal/WidgetCatalogProps";

import { VssComponent, WrappedComponent } from "VSS/Platform/Layout";

/** Encapsulates delay-loaded Widget Catalog Experience. */
export class WidgetCatalogProxy extends VssComponent<WidgetCatalogProps> {
    public render(): JSX.Element | null {
        return (
            <div className="dashboards-widget-inline-catalog flex-column flex-noshrink scroll-hidden">
                <WrappedComponent
                    wrappedType={"WidgetCatalogView"}
                    dependencies={["ms.vss-dashboards.dashboards-widget-catalog-ui"]}
                    wrappedProps={this.props}
                />
            </div>
        );
    }
}
